import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from "react-router-dom";

import { query, where, collection, getDocs, doc, getDoc } from "firebase/firestore";
import { db } from "../firebase.js";
import Cookies from "js-cookie";
import { Helmet } from "react-helmet";

import { Toast } from '../components_root/ToastContext.jsx';
  
import { Randomcode } from '../components_root/rendom_code.js'; 
import { MdCalendarMonth, MdDone, MdDoneAll } from 'react-icons/md';
export const seo = {
  title: "Aooz.in | Price | WhatsApp, RCS & SMS Marketing Platform for Business Growth",
  description:
    "Aooz.in offers price powerful WhatsApp, RCS, and SMS marketing solutions to reach the right audience, boost engagement, and grow your business efficiently.",
  keywords:
    "AOOZ services, Aooz.in, price WhatsApp marketing, RCS messaging, SMS marketing, bulk WhatsApp messages, business messaging platform, customer engagement, digital marketing tools",
  url: "https://aooz.in/whatsapp",
  image: "https://aooz.in/assets/logo.png"
};
export default function Billing() {
    const { Toastshow } = Toast();
    const navigate = useNavigate();
    const [companydata, setCompanydata] = useState([]);
    const [servicesdata, setServicesdata] = useState([]);
    const [serviceid, setServiceId] = useState("nHjKn3hpo5HL5fAcw9JI");
    const servicetablename = "accountingfinancedb"; 
    //staff account verify
    const [companiesstatus, setCompaniesstatus] = useState(false);  
    //Verify_services_status
    const [services_status, setServices_status] = useState(false); 
    const [userlogin, setuserlogin] = useState(false);

    const [guid, setGuid] = useState("");
    useEffect(() => {
        const existingsessiontoken = Cookies.get("sessiontoken");
        const guids = Cookies.get("guid");
        if (existingsessiontoken !== null && existingsessiontoken !== undefined && guids !== null && guids !== undefined) {
            setuserlogin(true);
            setGuid(guid);
        } else {
            // navigate("../login");
        }
    }, [navigate]);

 
  
    useEffect(() => {
        if (!serviceid) return;

        const fetchVoucher = async () => {
            try {
                const docRef = doc(db, "servicesdb", serviceid);
                const docSnap = await getDoc(docRef);
                if (!docSnap.exists()) return;
                setServicesdata([{ ...docSnap.data() }]);
            } catch (err) {
                console.error(err);
            }
        };

        fetchVoucher();
    }, [serviceid]);

 
    return (
        <div>
            <Helmet>
                <title>{seo.title}</title>
                <meta name="description" content={seo.description} />
                <meta name="keywords" content={seo.keywords} />
                <meta property="og:title" content={seo.title} />
                <meta property="og:description" content={seo.description} />
                <meta property="og:image" content={seo.image} />
                <meta property="og:url" content={seo.url} />
            </Helmet>

            <div className="container_roots relative">

 
                <div className="container_size_info p-3 z-index-2">

                    {servicesdata.length > 0 && servicesdata.map((row) => (
                        <div key={row.id}  >

                            <table>
                                <tr>
                                    <td className='text-hero bold center'>Control Your Business</td>
                                </tr>
                                <tr>
                                    <td>

                                        <div className="text-h1 bold center" >{row.name}</div>
                                    </td>
                                </tr>
                                <tr>

                                    <td>
                                        <div className="text-h2 text-pre center test-off"  >{row.description}</div>
                                    </td>
                                </tr>
                            </table>

                        </div>
                    ))}


                </div>
                <div className="container_size_info2 rounded  z-index-2">

                    {servicesdata.length > 0 && servicesdata.map((row) => (
                        <div key={row.id} className="items-back shadow">
                            <div className="center border_top b-bottom">
                                <div className="text-hero orange bold fcap  center">

                                    <span className="text-h2 no-tx-text-loop black">Cost only</span>
                                    ₹{row.validity_day > 0
                                        ? (row.price / row.validity_day).toFixed(2)
                                        : "0.00"}
                                    <span className="text-h2 bold"> / day</span>
                                </div>
                            </div>
                            <div className='p-22'>
                                <table className='table_padding'>
                                    <tr>
                                        <td >
                                            <div className="text-h3 text-off fcap" >All accounting and stock management functions are available</div>
                                        </td>
                                        <td width={120}>
                                            <div className="button-ui0 text-h2  fcap bold" ><MdDone className='icon' />Yes</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <div className="text-h3 text-off fcap" >Options are provided based on your requirements, free of charge.</div>
                                        </td>
                                        <td >
                                            <div className="button-ui0 text-h2  fcap bold" ><MdDone className='icon' />Yes</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <div className="text-h3 text-off fcap" >As per requirement — Free setup</div>
                                        </td>
                                        <td  >
                                            <div className="button-ui0 text-h2  fcap bold" ><MdDone className='icon' />Yes</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <div className="text-h3 text-off " >POS Receipt</div>
                                        </td>
                                        <td >
                                            <div className="button-ui0 text-h2  fcap bold" ><MdDone className='icon' />Yes</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <div className="text-h3 text-off " >POS Billing</div>
                                        </td>
                                        <td >
                                            <div className="button-ui0 text-h2  fcap bold" ><MdDone className='icon' />Yes</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <div className="text-h3 text-off fcap" >Message Option</div>
                                        </td>
                                        <td>
                                            <div className="button-ui0 text-h2  fcap bold " ><MdDone className='icon' />Whatsapp</div>

                                        </td>
                                    </tr>
                                    <tr>
                                        <td  >
                                            <div className="text-h3 text-off fcap" >Message Option</div>
                                        </td>
                                        <td>
                                            <div className="button-ui0 text-h2  fcap bold " ><MdDone className='icon' />Text SMS</div>

                                        </td>
                                    </tr>

                                    <tr>
                                        <td >
                                            <div className="text-h3 text-off fcap" >Two-Step Queue Verification</div>
                                        </td>
                                        <td>
                                            <div className="button-ui0 text-h2  fcap bold " ><MdDone className='icon' />Queue</div>

                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <div className="text-h3 text-off fcap" >Validity day</div>
                                        </td>
                                        <td >
                                            <div className="button-ui0 text-h2  fcap bold" ><MdCalendarMonth className='icon' />{row.validity_day} Days</div>

                                        </td>

                                    </tr>

                                    <tr>
                                        <td >
                                            <div className="text-h3 text-off fcap" >Billing yearly</div>
                                        </td>
                                        <td>
                                            <div className="text-h2  fcap" >₹{row.price}/-</div>

                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <div className="text-h3 text-off fcap" >Tax (GST)</div>
                                        </td>
                                        <td>
                                            <div className="text-h2  fcap" >₹{row.tax_rate}%</div>

                                        </td>
                                    </tr>

                                    <tr>
                                        <td >
                                            <div className="text-h3 text-off fcap" >total Payable </div>
                                        </td>
                                        <td>
                                            <div className="text-h1 fcap bold">
                                                ₹{(row.price + (row.price * row.tax_rate / 100)).toFixed(2)}
                                            </div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <br />
                   
                        <div className='button-ui fill text-h2  bold fcap p-2 cursor' onClick={() => navigate(`/whatsapp?p=create-account&payment-gateway&token=${Randomcode(400)}&id=${row.serviceid}`)}>Start installation</div>
                   

                        </div>
                    ))}

                </div>
                <br />
                <div className="container_size_info z-index-2">
                    <div className=' text-h2 text-r'>Looking for corporate deals? <a href='https://aooz.in/support' className='bold cursor'>Contact us</a>  today.</div>
                </div>
                <div className="container_size p-3 z-index-2">

                    {servicesdata.length > 0 && servicesdata.map((row) => (
                        <div className="text-h3 text-pre" >{row.about}</div>
                    ))}
                </div>
            </div>

        </div >
    );
}
